export default {
  overview: {
    title: "Kategorien Übersicht",
    archive_title: "Archivierte Kategorien",
    subtitle: "Auflistung aller Kategorien.",
    search: {
      placeholder: "bspw. Name oder Beschreibung",
    },
    actions: {
      create_new: "Neue Kategorie erstellen",
    },
    table: {
      headers: {
        name: "Name",
        description: "Beschreibung",
        createdAt: "Erstellt am",
      },
      empty: {
        description: "Nicht gesetzt",
      },
    },
  },
  create: {
    title: "Kategorie Anlegen",
    subtitle: "Neue Kategorie anlegen.",
  },
  detail: {
    title: "Kategorie Details",
    tabs: {
      general: "Allgemein",
      activity: "Protokoll",
    },
    actions: {
      update: "Speichern",
    },
    form: {
      name: "Name",
      description: "Beschreibung",
      description_hint: "Optionale Beschreibung der Kategorie",
    },
  },
  component: {
    tagField: {
      create: 'Kategorie „{value}" anlegen',
      empty: "Tippen Sie einen Namen, um eine Kategorie anzulegen.",
      no_match: "Keine Kategorie gefunden.",
    },
    catalogue: {
      title: "Kategorien verwalten",
      subtitle: "Die Kategorien des ganzen Betriebs. Ein Klick auf eine Kategorie bearbeitet Name und Beschreibung.",
      empty: "Noch keine Kategorien angelegt.",
      add: "Kategorie hinzufügen",
      search: "Nach Name oder Beschreibung suchen",
      no_match: "Keine Kategorie passt zur Suche.",
      count: "{count} Kategorie | {count} Kategorien",
      name: "Name",
      description: "Beschreibung (optional)",
      no_description: "Keine Beschreibung",
      name_taken: "Eine Kategorie mit diesem Namen gibt es schon.",
      rename_hint: "Die Änderung gilt überall, wo die Kategorie verwendet wird.",
      remove_title: "Kategorie entfernen?",
      remove_text:
        'Die Kategorie „{name}" verschwindet aus der Auswahl. Wird sie schon in [[hwr.datpl]] verwendet, bleibt sie dort erhalten und kommt ins Archiv. Sonst wird sie gelöscht.',
    },
  },
}
